import React, { useRef } from 'react'
import { Stepper } from 'primereact/stepper'
import { StepperPanel } from 'primereact/stepperpanel'
// import { useAppSelector } from '../../../../store/hooks'
import { Button } from 'react-bootstrap'
import FormActions from '../../../common/forms/FormActions'
import WebsiteTemplates from './components/WebsiteTemplates'
import PageHeader from '../../../layout/page/PageHeader'

const WebsiteBuilder = () => {
    // const theme = useAppSelector((state) => state.theme.theme)

    const stepperRef = useRef(null)

    return (
        <>
            <PageHeader
                icon="wrench"
                subtitle="Visually build and edit your website pages"
                gradient="linear-gradient(135deg, #64748b, #475569)"
                header="Build your website"
            />
            <div className="card flex justify-content-center py-4">
                <Stepper ref={stepperRef}>
                    <StepperPanel header="Choose Template">
                        <div className="flex flex-column">
                            <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                                <WebsiteTemplates />
                            </div>
                        </div>
                        <div className="flex pt-4 justify-content-end">
                            <FormActions
                                formFooter={
                                    <Button
                                        variant="outline-primary"
                                        onClick={() =>
                                            stepperRef.current.nextCallback()
                                        }
                                    >
                                        Next
                                    </Button>
                                }
                            />
                        </div>
                    </StepperPanel>
                    <StepperPanel header="Edit &amp; Save">
                        <div className="flex flex-column">
                            <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                                Content II
                            </div>
                        </div>
                        <div className="flex pt-4 justify-content-between">
                            <FormActions
                                formFooter={
                                    <>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() =>
                                                stepperRef.current.prevCallback()
                                            }
                                        >
                                            Back
                                        </Button>
                                        <Button
                                            variant="info"
                                            // onClick={() =>
                                            //     stepperRef.current.nextCallback()
                                            // }
                                        >
                                            Preview
                                        </Button>
                                        <Button
                                            variant="success"
                                            onClick={() =>
                                                stepperRef.current.nextCallback()
                                            }
                                        >
                                            Save
                                        </Button>
                                    </>
                                }
                            />
                        </div>
                    </StepperPanel>
                    <StepperPanel header="Publish">
                        <div className="flex flex-column">
                            <div className="border-2 border-dashed surface-border border-round surface-ground flex-auto flex justify-content-center align-items-center font-medium">
                                Content III
                            </div>
                        </div>
                        <div className="flex pt-4 justify-content-start">
                            <FormActions
                                formFooter={
                                    <>
                                        <Button
                                            variant="outline-secondary"
                                            onClick={() =>
                                                stepperRef.current.prevCallback()
                                            }
                                        >
                                            Back
                                        </Button>
                                        <Button
                                            variant="info"
                                            // onClick={() =>
                                            //     stepperRef.current.nextCallback()
                                            // }
                                        >
                                            Preview
                                        </Button>
                                        <Button
                                            variant="success"
                                            onClick={() =>
                                                stepperRef.current.nextCallback()
                                            }
                                        >
                                            Publish
                                        </Button>
                                    </>
                                }
                            />
                        </div>
                    </StepperPanel>
                </Stepper>
            </div>
        </>
    )
}

export default WebsiteBuilder
